import { render, staticRenderFns } from "./CostSettings.vue?vue&type=template&id=1b513cb2"
import script from "./CostSettings.vue?vue&type=script&lang=js"
export * from "./CostSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports